import React from "react";
import DateList from "./../DateList";
import TimelineComponent from "./../TimelineComponent";
import { ViewChooserNav, ViewWrapper } from "./elements";

const ViewChooser = ({ data }) => {
  const [currentView, setCurrentView] = React.useState("cards");
  return (
    <div>
      <ViewChooserNav>
        View as:{" "}
        <a
          href="/#"
          className={currentView === "cards" ? "selected" : ""}
          onClick={(e) => {
            e.preventDefault();
            setCurrentView("cards");
          }}
        >
          Cards
        </a>
        <a
          href="/#"
          className={currentView === "timeline" ? "selected" : ""}
          onClick={(e) => {
            e.preventDefault();
            setCurrentView("timeline");
          }}
        >
          Timeline
        </a>
      </ViewChooserNav>
      <ViewWrapper key={currentView} timeline={currentView === "timeline"}>
        {currentView === "cards" ? (
          <DateList data={data} />
        ) : (
          <TimelineComponent data={data} />
        )}
      </ViewWrapper>
    </div>
  );
};

export default ViewChooser;
